// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  display: flex;
  justify-content: center;
  align-items: center;
  height: calc(100vh - 48px);
  width: 100vw;
  text-align: center;
}

.container {
  width: 100%;
}`, "",{"version":3,"sources":["webpack://./src/shared/components/page-not-found/page-not-found.component.scss"],"names":[],"mappings":"AAAA;EACI,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,0BAAA;EACA,YAAA;EACA,kBAAA;AACJ;;AAEA;EACI,WAAA;AACJ","sourcesContent":[":host {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    height: calc(100vh - 48px);\n    width: 100vw;\n    text-align: center;\n}\n\n.container {\n    width: 100%;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
